import { CalculatorTranslations } from "../models/CalculatorTranslations";

export function mapFormError(error: string | undefined, translations: CalculatorTranslations): string {
    if (!error) {
        return ''
    }

    if (error in translations) {
        return translations[error as keyof typeof translations];
    }

    return translations.Required;
}